import { render } from "./AccidentDashboard.vue?vue&type=template&id=d22848ba"
import script from "./AccidentDashboard.vue?vue&type=script&lang=js"
export * from "./AccidentDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__